<div
  [ngClass]="{'indic-suggestion-overlaypanel ui-widget ui-widget-content ui-corner-all ui-shadow card bg-white box-shadow':true,'border-default':manglishPattern&&letters?.length>1}"
  [style.display]="visible ? 'block' : 'none'" data-bs-toggle="tooltip"
  title="Press <Tab> for next character" #divParent>

  <div class="indic-suggestion-overlaypanel-content">
    <!-- <span *ngIf="isFocused&&!manglishPattern">Press <kbd>Tab</kbd> for manglish suggestion</span> -->
    <ul class="indic-suggest" *ngIf="manglishPattern&&letters?.length>1">
      <kbd *ngIf="manglishPattern&&letters?.length>1">Tab</kbd>
      <li *ngFor="let letter of letters; let i = index" class="text-center" [ngClass]="{'selected': isActive(letter, i)}">
        <a>{{letter |manglish}}</a>
      </li>

    </ul>
  </div>

</div>